import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { BKJTextInput } from '../../BKJTextInput/index.js';
import { useBKJTimeInputContext } from './BKJTimeInput.context.js';
export const BKJTimeInputInput = ({ className, autoComplete, css, overrides, ...rest }) => {
    const { label, variant = 'ComboBoxSeamlessRounded', action, error, setAnchorElement, getInputProps, isOpen, onInputFocus, onInputBlur, onInputKeyDown, name, leftIconProps, leftIconName, disabled, placeholder, required, inputValue, value, reset, onSelectedClear, anchorElement, openMenu, closeMenu, pendingCursorPosition, } = useBKJTimeInputContext();
    const rightIconClassName = 'bkj-timeinput-dropdown-icon';
    let rightIconProps = undefined;
    switch (action) {
        case 'ClearInputValue':
            if (inputValue) {
                rightIconProps = {
                    iconName: 'CloseBold',
                    onClick: reset,
                    className: rightIconClassName,
                };
            }
            break;
        case 'ClearSelectedValue':
            if (value && value.length > 0) {
                rightIconProps = {
                    iconName: 'CloseBold',
                    onClick: onSelectedClear,
                    className: rightIconClassName,
                };
            }
            break;
        case 'OpenToggle':
            rightIconProps = {
                className: rightIconClassName,
                isOpen,
                iconName: 'ArrowDown',
                onClick: disabled
                    ? undefined
                    : () => {
                        if (!isOpen) {
                            anchorElement?.focus();
                            openMenu();
                        }
                        else {
                            closeMenu();
                        }
                    },
            };
            break;
    }
    const stableRef = useCallback((node) => {
        setAnchorElement((prev) => (prev !== node ? node : prev));
    }, [setAnchorElement]);
    const { id: _dsInputId, 'aria-labelledby': _dsLabelledBy, ...inputProps } = getInputProps({
        ...rest,
        onKeyDown: (e) => {
            onInputKeyDown(e);
        },
        onFocus: onInputFocus,
        ref: stableRef,
        placeholder,
        required,
        name,
        label,
        disabled,
    });
    const handleBlur = useCallback(() => {
        onInputBlur();
        closeMenu();
    }, [closeMenu, onInputBlur]);
    const handleClick = useCallback(() => {
        // downshift v6's InputClick reducer toggles isOpen, which would close the
        // dropdown immediately after onInputFocus opened it. Override with an
        // open-only handler so clicks into or within the input keep the menu open.
        if (!isOpen)
            openMenu();
    }, [isOpen, openMenu]);
    const handleChange = useCallback((e) => {
        pendingCursorPosition.current = e.target.selectionStart;
        if (inputProps.onChange) {
            inputProps.onChange(e);
        }
    }, [inputProps, pendingCursorPosition]);
    return (_jsx(BKJTextInput, { isOpen: isOpen, variant: variant, ...inputProps, role: "combobox", "aria-haspopup": "listbox", "aria-expanded": isOpen, "aria-invalid": error ? true : undefined, onChange: handleChange, onBlur: handleBlur, onClick: handleClick, value: inputProps.value, autoComplete: autoComplete, className: `${inputProps.className} ${className}`, overrides: ['NO_REQUIRED'], rightIconProps: rightIconProps, leftIconProps: leftIconProps || leftIconName ? { ...leftIconProps, iconName: leftIconName } : undefined, useFocusBorder: false, error: error, css: css }));
};
//# sourceMappingURL=BKJTimeInputInput.js.map